<template>
    <div class="header-container">
        <!-- logo -->
        <div class="logo-container">
            <el-image class="logo-image" :src="require('../assets/images/qdys.jpg')"></el-image>
            <span class="logo-text">中国IT产品供应商推荐平台</span>
        </div>

        <!-- 导航栏 -->
         <!-- <div class="tablist" v-if="innerWidth>768">
             <div v-for="item in list" :key="item">
                 <div v-if="item === '联系我们' || item === '名企入驻'" @click="showContactDialog" class="tabitem" 
                 style="cursor: pointer; font-size: 14px; margin-left: -10px; margin-right: -10px;">{{ item }}</div>
                 <router-link v-else :to="getRoutePath(item)" class="tabitem">{{ item }}</router-link>
             </div>
        </div> -->
        <div class="tablist" v-if="innerWidth>768">
            <div v-for="item in list" :key="item">
                <router-link  
                    v-if="item !== '联系我们' && item !== '名企入驻'" 
                    :to="getRoutePath(item)" 
                    class="tabitem"
                >{{ item }}</router-link>
            
                <router-link
                    v-else
                    to=""
                    class="tabitem"
                    @click.native.prevent="showContactDialog"
                >{{ item }}</router-link>
            </div>
        </div>
 
         <el-dropdown trigger="click" v-else >
             <span class="el-dropdown-link">
                 <i class="el-icon-menu" style="font-size: 2em; color: #666;"></i>
             </span>
             <el-dropdown-menu slot="dropdown" >
                 <el-dropdown-item v-for="item in list" :key="item">
                     <!-- <div v-if="item === '联系我们' || item === '名企入驻'" @click="showContactDialog" style="margin-right: 10px; cursor: pointer; color: black;">{{ item }}</div>
                     <router-link v-else :to="getRoutePath(item)" style="margin-right: 10px;">{{ item }}</router-link> -->
                     <router-link  
                        v-if="item !== '联系我们' && item !== '名企入驻'" 
                        :to="getRoutePath(item)" 
                        class="tabitem"
                    >{{ item }}</router-link>
                
                    <router-link
                        v-else
                        to=""
                        class="tabitem"
                        @click.native.prevent="showContactDialog"
                    >{{ item }}</router-link>
                 </el-dropdown-item>
             </el-dropdown-menu>
         </el-dropdown>
       
        <!-- 联系弹窗 -->
        <ContactDialog :visible.sync="contactDialogVisible" :qrcodeImage="qrcodeImage" />
    </div>
</template>

<script>
import Cookie from 'js-cookie'
import { useRouter } from 'vue-router'
import ContactDialog from './ContactDialog.vue'


export default {
    components: {
        ContactDialog
    },
    props:{
        innerWidth: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            activeIndex: '1',
            list:['首页','供应商','新闻资讯','名企入驻','联系我们'],
            contactDialogVisible: false,
            qrcodeImage: require('../assets/images/qrcode.jpg')
        }
    },
    setup() {
        const router = useRouter()
        return {
            router
        }
    },
    methods: {
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },
        getRoutePath(item) {
            const routes = {
                '首页': '/',
                '供应商': '/enterprise-display',
                '新闻资讯': '/news',
                '名企入驻': '/Detail',
                '联系我们': '/Detail'
            }
            return routes[item] || '/'
        },
        showContactDialog() {
            this.contactDialogVisible = true;
        }
    },
    computed: {
    }
}
</script>

<style lang="less" scoped>

.logo-container {
    display: flex;
    align-items: flex-end;
    gap: 0.5em;
    padding: 0.5em 0.5em;
}

.logo-image {
    width: 10em;
    height: auto;
}

.logo-text {
    font-size: 20px;
    line-height: 1;
    color: #333;
    /* font-weight: 500; */
    margin-bottom: 7px;
}

@media (max-width: 767px) {
    .header-container{
        padding: 10px 10px 10px 0px;
    }
    .logo-container {
        padding: 0.5em 0.3em;
    }
    .logo-image {
        width: 6em;
    }
    .logo-text { 
        margin-bottom: 3px;
        margin-top: 2px;
        /* border: 1px solid; */
        margin-left: -8px;
        font-size: 12px;
    }
}

/* 平板样式 */
@media (min-width: 768px) and (max-width: 1023px) {
    .header-container{
        padding: 15px 10px 10px 20px;
    }
}

/* 桌面样式 */
@media (min-width: 1024px) {
    .header-container{
        padding: 15px 10px 10px 20px;
    }
}
.header-container {
   
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:0 20px ;

    .el-menu-demo {
        overflow: hidden;
        height: 100%;
        // flex: 1;
        // display: flex;
        // justify-content: end;
        border-bottom: 0;

    }

    .el-menu-item {
        font-size: 0.9em;
    }

    /deep/.el-breadcrumb__item {
        .el-breadcrumb__inner {
            font-weight: normal;

            &.is-link {
                color: #666;
            }
        }

        &:last-child {
            .el-breadcrumb__inner {
                color: #fff;
            }
        }
    }

}
.tablist{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;

    .tabitem{
        text-align: center;
        width: 6em;
        font-size: 0.9em;
        color: black;
       

        &:hover {
            color: #FF6600;
          
        }
    }
    .router-link-active {
        text-decoration: none;
        color: black;
    }
    a {
    text-decoration: none;
        // color: #fff;
        color: black;
    }
}
.el-dropdown-menu__item {
   line-height: 40px!important;
   padding: 0 26px!important;
               //手机菜单栏清除样式
  
   &:hover {
     background-color: #fff!important;
     border-radius: 5px!important;
     color: #FF6600;
   }
   a:link { color: black; text-decoration: none; }
   a:visited { color:  black; text-decoration: none; } 
   a:active { color: #FF6600; }

   .router-link-active {
        text-decoration: none;
        color: black;
    }

 }



</style>